import { render, staticRenderFns } from "./eleBoxHistory.vue?vue&type=template&id=85e477b6&scoped=true&"
import script from "./eleBoxHistory.vue?vue&type=script&lang=js&"
export * from "./eleBoxHistory.vue?vue&type=script&lang=js&"
import style0 from "./eleBoxHistory.vue?vue&type=style&index=0&id=85e477b6&scoped=true&lang=css&"
import style1 from "./eleBoxHistory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e477b6",
  null
  
)

export default component.exports